import { Button } from "components/ui/button"
import { Loader2 } from "lucide-react"
import type { ConfirmationModalProps } from "../../types/components"
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogFooter,
} from "@/components/ui/alert-dialog"

export const RejectConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedCount,
  isLoading
}: ConfirmationModalProps) => (
  <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
    <AlertDialogContent
      className="max-w-md z-[60]"
      onEscapeKeyDown={(e) => e.stopPropagation()}
    >
      <AlertDialogHeader>
        <AlertDialogTitle className="text-lg font-semibold text-[#4B303C]">
          Confirmar Reprovação
        </AlertDialogTitle>
      </AlertDialogHeader>

      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          Tem certeza que deseja reprovar <strong>{selectedCount}</strong> item(s) selecionado(s)?
        </p>
        <p className="text-xs text-gray-500">
          Esta ação não pode ser desfeita. Os itens serão marcados como rejeitados.
        </p>
      </div>

      <AlertDialogFooter>
        <Button
          variant="outline"
          onClick={onClose}
          disabled={isLoading}
        >
          Cancelar
        </Button>
        <Button
          variant="destructive"
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? (
            <Loader2 className="w-4 h-4 mr-1 animate-spin" />
          ) : null}
          {isLoading ? "Processando..." : "Confirmar Reprovação"}
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
)
